import { LOCALIZATIONS } from 'root/lib/constants';
import audio from '../assets/audio/curioso';
import sfxCuriosoCommon from '../assets/sfx/commonCurioso/SFXMap';
import { getRandomInt } from '../../../lib/utilityFunctions';
import { AquaHowl } from '../../../lib/AquaHowl';

let curiosoEmotesIndex = 3;

export function playCuriosoSound(audioName, play = true) {
  if (typeof audioName === 'string' && audioName.length > 0 && play) {
    return new Promise((resolve) => {
      new AquaHowl({
        src: [sfxCuriosoCommon[audioName]],
        onend: resolve,
      }).play();
    });
  }
  return Promise.resolve();
}

export function curiosoEmotes(playAudio = true) {
  if (playAudio) {
    curiosoEmotesIndex++;
    if (curiosoEmotesIndex === 6) {
      curiosoEmotesIndex = 3;
    }
    this.curiosoEmotesSequence = new AquaHowl({
      src: [sfxCuriosoCommon[`hub_curioso_emote_${curiosoEmotesIndex}_sfx`]],
    }).play();
  }
}

export function curiosoNotHappyEmotes(playAudio = true) {
  if (playAudio) {
    this.curiosoNotHappyEmotesSequence = new AquaHowl({
      src: [sfxCuriosoCommon.hub_curioso_emote_2_sfx],
    }).play();
  }
}

/*
  Usage: Curioso Customization Intro [user taps]
  VO: What a handsome little fella!
  (chuckling) Looks like it can’t wait to use it!
  */
export function playCuriosoAugmentationApplied(
  fistAugmentationWasApplied = false,
  playAudio = true,
  isDefaultItem = false,
) {
  if (this.whatAHandsomeFellaSequence && this.whatAHandsomeFellaSequence.unload) {
    this.whatAHandsomeFellaSequence.unload();
  }
  if (playAudio) {
    if (!fistAugmentationWasApplied && !isDefaultItem) {
      const whatAHandsomeFellAudio =
        this.props.localization === LOCALIZATIONS.SPA_ES_DEFAULT
          ? audio.custom_tutorial_what_a_handsome_es
          : audio.custom_tutorial_what_a_handsome;

      this.whatAHandsomeFellaSequence = this.props.playAudio(whatAHandsomeFellAudio, {
        html5: false,
        onend: () => {
          this.whatAHandsomeFellaSequence = this.props.playAudio(
            sfxCuriosoCommon[`hub_curioso_emote_${getRandomInt(3, 6)}_sfx`],
            { html5: false },
          );
        },
      });
    } else {
      this.whatAHandsomeFellaSequence = this.props.playAudio(
        sfxCuriosoCommon[`hub_curioso_emote_${getRandomInt(3, 6)}_sfx`],
        { html5: false },
      );
    }
  }
}
